import { render, staticRenderFns } from "./fixed-assets.vue?vue&type=template&id=4b0f5386&scoped=true&"
import script from "./fixed-assets.vue?vue&type=script&lang=js&"
export * from "./fixed-assets.vue?vue&type=script&lang=js&"
import style0 from "./fixed-assets.vue?vue&type=style&index=0&id=4b0f5386&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f5386",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
